import { ReferralApi, type ReferralCustomerType } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import { convertApiError } from "../convertApiError";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type GetLoyaltyReferralCustomerEndpointArgs = { uuid: string; ciam_token?: string };
export type GetLoyaltyReferralCustomerEndpointResponse = Pick<
  ReferralCustomerType,
  "parent_code" | "has_first_purchase"
>;

export const getLoyaltyReferralCustomerEndpoint = (builder: LoyaltyApiBuilder) => ({
  getLoyaltyReferralCustomer: builder.query<
    GetLoyaltyReferralCustomerEndpointResponse,
    GetLoyaltyReferralCustomerEndpointArgs
  >({
    queryFn: async ({ uuid, ciam_token }) => {
      try {
        const referralApi = ReferralApi.init();
        const data = await referralApi.getCustomer(uuid, ciam_token ?? "", true);
        return { data };
      } catch (error: unknown) {
        return convertApiError(error);
      }
    },
    providesTags: [TAGS.LOYALTY_REFERRAL],
  }),
});
